var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgAlertBell(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "alertBell_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "alertBell_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement(Path, {
    className: "alertBell_svg__cls-1",
    d: "M20 1c10.48 0 19 8.52 19 19s-8.52 19-19 19S1 30.48 1 20 9.52 1 20 1m0-1C8.95 0 0 8.95 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "alertBell_svg__cls-1",
    d: "M27.09 25.36v-7.99c0-3.55-2.59-6.51-5.97-7.1V9.02c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v1.25c-3.39.59-5.97 3.54-5.97 7.1v7.99l-2.47.94v1.47h19.37V26.3l-2.47-.94zm-9.89 3.76a2.68 2.68 0 005.36 0v-.21H17.2v.21z"
  }))));
}
export default SvgAlertBell;